import type { IconData } from '@stacksjs/iconify-core'

export const otherUiCall: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 2c0 7.732 6.268 14 14 14h2V9h-4l-2 2l-5-5l2-2V0H0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiCall
